export const SaleOutlineIcon = ({
  width = 13,
  height = 13,
  className,
  title = "Sale Outline",
  ...rest
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 13"
      fill="none"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path
        d="M11.1583 7.25833L5.95829 2.05833H2.16663V5.85L7.36663 11.05C7.56913 11.2485 7.84139 11.3597 8.12496 11.3597C8.40853 11.3597 8.68079 11.2485 8.88329 11.05L11.1583 8.775C11.3568 8.5725 11.468 8.30023 11.468 8.01667C11.468 7.7331 11.3568 7.46084 11.1583 7.25833Z"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
